import { createVanIconComponent } from "./van"

const CashOnDeliver = createVanIconComponent("cash-on-deliver")
export default CashOnDeliver
